
const requestsMap = {
    getMeasurementData: {
        method: "GET",
        url: function(){
            return `https://ai-demo-api.unbxd.io/query_understanding/verticals/apparel/measurements`
        }
    },
    getNerResults: {
        method: "GET",
        url: function(params) {
            const { vertical } = params;
            return `https://ai-demo-api.unbxd.io/query_understanding/verticals/${vertical}/tag`
        }
    }
}

export default requestsMap;
